import { LinearProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import axios from "axios";
import AlertBox from "../../component/AlertBox";
import PasswordField from "../../component/PasswordField";
import { SERVER_URL } from "../../constant";

function SAResetPassword() {
  const isSuperadmin = useSelector(
    (state) => state.superadmin?.isSuperadminAuthenticated
  );
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isSuperadmin !== undefined && isSuperadmin === false) {
      navigate("/superadmin/signin");
    }
  }, [isSuperadmin]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  async function resetPassword() {
    if (newPassword.trim() === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Password is required");
      return null;
    }
    const data = {
      newPassword: newPassword,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/superadmin/reset/password`,
        method: "post",
        data: data,
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Password has been changed successfully");
        setNewPassword("")
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Password change failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[30rem] py-5">
          <h1 className="text-[30px] font-medium text-center w-full">
            Reset Password
          </h1>
          <div className="w-full mt-5">
            <PasswordField onChange={(event) => setNewPassword(event.target.value)} value={newPassword} />
          </div>
          <div className="mt-5 flex justify-end">
            <ButtonCompo variant={"contained"} onClick={resetPassword}>Save</ButtonCompo>
          </div>
        </div>
      </div>
    </>
  );
}

export default SAResetPassword;
